import { Icon } from '@mui/material'
import Grid from '@mui/material/Grid'
import React, { PropsWithChildren, ReactElement } from 'react'

import styles from './FormRow.module.less'

type FormRowProps = {
  icon?: string
  iconMarginLeft?: boolean
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
  onMouseUp?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  style?: React.CSSProperties
  'data-testid'?: string
}

function FormRow({
  icon,
  spacing,
  iconMarginLeft,
  children,
  onMouseUp,
  style,
  'data-testid': dataTestId,
}: PropsWithChildren<FormRowProps>): ReactElement {
  return (
    <Grid
      container
      direction="row"
      onMouseUp={onMouseUp}
      style={style}
      data-testid={dataTestId}
      className={styles.FormRow}
      wrap="nowrap"
    >
      {(icon || iconMarginLeft) && (
        <Grid
          container
          sx={{ width: 40, flex: '0 0 40px' }}
          alignItems="flex-start"
          justifyContent="center"
          className={styles.FormRow_Icon}
        >
          {icon ? <Icon className={icon} /> : null}
        </Grid>
      )}
      <Grid
        container
        flexGrow={1}
        spacing={spacing !== undefined ? spacing : 1}
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        wrap="wrap"
      >
        {children}
      </Grid>
    </Grid>
  )
}

export default FormRow
